class RootsSupportFab extends HTMLElement {
  #open = false;
  #bound = false;

  /**
   * Held in a private field: `popover` is a reflected HTMLElement property
   * (Popover API) — assigning to `this.popover` would stamp a `popover`
   * attribute on the host and let the UA popover styles center it on screen.
   */
  #popover = null;

  connectedCallback() {
    this.toggle = this.querySelector('[data-roots-fab-toggle]');
    this.#popover = this.querySelector('[data-roots-fab-popover]');
    if (!this.toggle || !this.#popover) return;
    if (this.#bound) return;
    this.#bound = true;

    this.toggle.addEventListener('click', this.#onToggleClick);
    this.addEventListener('keydown', this.#onKeydown);
    this.querySelectorAll('[data-roots-fab-channel]').forEach((link) => {
      link.addEventListener('click', this.#onChannelClick);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onDocumentClick, true);
    document.removeEventListener('focusin', this.#onDocumentFocus, true);
    if (this.toggle) this.toggle.removeEventListener('click', this.#onToggleClick);
    this.removeEventListener('keydown', this.#onKeydown);
    this.querySelectorAll('[data-roots-fab-channel]').forEach((link) => {
      link.removeEventListener('click', this.#onChannelClick);
    });
    this.#bound = false;
  }

  get open() {
    return this.#open;
  }

  set open(value) {
    const next = Boolean(value);
    if (next === this.#open) return;
    this.#open = next;

    this.classList.toggle('is-open', next);
    this.toggle.setAttribute('aria-expanded', String(next));
    this.toggle.setAttribute(
      'aria-label',
      next ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen
    );
    this.#popover.toggleAttribute('inert', !next);

    if (next) {
      document.addEventListener('click', this.#onDocumentClick, true);
      document.addEventListener('focusin', this.#onDocumentFocus, true);
      if (this.toggle.matches(':focus-visible')) {
        const firstLink = this.#popover.querySelector('a, button');
        if (firstLink) firstLink.focus({ preventScroll: true });
      }
    } else {
      document.removeEventListener('click', this.#onDocumentClick, true);
      document.removeEventListener('focusin', this.#onDocumentFocus, true);
    }
  }

  #onToggleClick = () => {
    this.open = !this.open;
  };

  #onChannelClick = () => {
    this.open = false;
  };

  #onKeydown = (event) => {
    if (event.key === 'Escape' && this.open) {
      this.open = false;
      this.toggle.focus();
    }
  };

  #onDocumentClick = (event) => {
    if (!this.contains(event.target)) this.open = false;
  };

  #onDocumentFocus = (event) => {
    if (!this.contains(event.target)) this.open = false;
  };
}

if (!customElements.get('roots-support-fab')) {
  customElements.define('roots-support-fab', RootsSupportFab);
}
